import type { LogisticRequestType } from '@outkeep/shared';

export type Product = {
  id: number;
  deviceModel: number | null;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  isPrivate?: boolean | null;
  requestType?: LogisticRequestType;
};

export type AvailableProductsQueryParams = {
  forRequestId?: number;
  forCounterpartyId?: number;
  requestType?: LogisticRequestType;
  requestTypes?: LogisticRequestType[];
  isPrivate?: boolean;
  scopeToVisibleRequests?: boolean;
};

export enum RequestProducts {
  ServiceCall = 1, // Услуга выезда
  XKeeperINVISDUOS = 2, // X-Keeper INVIS DUOS
  XKeeperOBDII = 3, // X-Keeper OBD II
  XKeeperInvisDUOSS = 4, // X-Keeper Invis DUOS S
  EquipmentInstallation = 5, // Установка оборудования
  LSAcceptanceAndTransfer = 6, // Приемка-передача ПЛ
  Signing = 7, // Подписание
  Inspection = 8, // Осмотр ПЛ/Имущества/Бизнеса
  FuelCardsTransfer = 9, // Передача топливных карт
  XKeeperInvisDUOS3DL = 10, // X-Keeper Invis DUOS 3D L
  ActsSigning = 11, // Подписание актов (неявка / отказ)
  Marking = 12, // Маркировка
  EquipmentAcceptanceAndTransfer = 13, // Приемка-передача оборудования
  InspectionWithBooster = 14, // Осмотр с бустером
  PreparationOfPassengerVehicle = 15, // Подготовка легкового ТС
  PreparationOfCommercialVehicle = 16, // Подготовка грузового ТС/спец техники
  DemonstrationOfPL = 17, // Демонстрация ПЛ
  DemonstrationOfPLWithBooster = 18, // Демонстрация ПЛ с бустером
  AntivandalProtectiveCase = 19, // Чехол защитный антивандальный
  Magnet20x3 = 20, // Магнит 20x3
  XKeeperOnlineSlim = 21, // X-Keeper ONLINE SLIM
  XKeeperInvisDUOSContainerTracker = 22, // X-Keeper Invis DUOS Container Tracker
  WarrantyServiceM1 = 23, // Гарантийный выезд (М1)
  WarrantyService = 24, // Гарантийный выезд
  WarrantyServiceM2 = 29, // Гарантийный выезд (М2)
  WarrantyServiceM3 = 30, // Гарантийный выезд (М3)
  WarrantyServiceM4 = 31, // Гарантийный выезд (М4)
  WarrantyServiceM5 = 32, // Гарантийный выезд (М5)
  WarrantyServiceSubsequent = 33, // Гарантийный выезд (последующие)
  MonitoringWithoutEngineBlock = 35, // Установка мониторинга без блокирови ДВС
  MonitoringWithEngineBlock = 36, // Установка мониторинга с блокировкой ДВС
}
